import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ToastProvider } from "./components/Toast";
import { supabaseConfigError } from "./lib/supabase";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element in index.html");

const root = createRoot(rootEl);

if (supabaseConfigError) {
  root.render(
    <StrictMode>
      <ConfigErrorScreen message={supabaseConfigError} />
    </StrictMode>,
  );
} else {
  root.render(
    <StrictMode>
      <ToastProvider>
        <App />
      </ToastProvider>
    </StrictMode>,
  );
}

function ConfigErrorScreen({ message }: { message: string }) {
  return (
    <main className="min-h-screen px-4 py-10 sm:px-6 sm:py-16">
      <div className="mx-auto max-w-md">
        <h1 className="display text-3xl tracking-tight text-fg-0">
          Configuration error
        </h1>
        <p className="mt-2 text-sm text-fg-1">
          The app is missing build-time configuration. This is a deploy
          problem, not a user problem.
        </p>
        <pre className="mt-4 whitespace-pre-wrap rounded-md border border-accent-bad/30 bg-accent-bad/10 px-3 py-2 text-sm text-accent-bad">
          {message}
        </pre>
        <p className="mt-4 kicker">Build environment seen by Vite</p>
        <dl className="mt-2 grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1 text-xs">
          <dt className="font-medium text-fg-1">VITE_SUPABASE_URL</dt>
          <dd className="num text-fg-0">
            {import.meta.env.VITE_SUPABASE_URL ? "(set)" : "(missing)"}
          </dd>
          <dt className="font-medium text-fg-1">VITE_SUPABASE_ANON_KEY</dt>
          <dd className="num text-fg-0">
            {import.meta.env.VITE_SUPABASE_ANON_KEY ? "(set)" : "(missing)"}
          </dd>
          <dt className="font-medium text-fg-1">VITE_API_URL</dt>
          <dd className="num text-fg-0">
            {import.meta.env.VITE_API_URL ?? "(missing — relative paths only)"}
          </dd>
        </dl>
      </div>
    </main>
  );
}
